module.exports = __webpack_public_path__ + "static/media/BigWarningIcon.bfc78bb2.svg";